<template>
  <label class="hadb-upload">
    <div v-if="drag" class="hadb-upload__drag" @drop="handleDragFile">
      <slot>
        <div class="drag-inner center bdrs">
          <span class="drag-icon__container center bg-linear-primary">
            <q-icon class="drag-icon" name="add" />
          </span>
          <p class="drag-label font-body">点击上传<br />或将文件拖拽到此</p>
        </div>
      </slot>
    </div>
    <slot v-else></slot>
    <input
      type="file"
      ref="input"
      class="hadb-upload__input"
      @input="handleFileChange"
      :accept="fileAccept"
      multiple
    />
  </label>
</template>

<script>
import { mapState } from 'vuex';
import { dataURLtoFile, getFileDataURL } from '../../config/utils';
export default {
  name: 'HadbUpload',

  props: {
    fileAccept: {
      type: String,
      default: '.jpg,.png,.jpeg'
    },
    drag: {
      type: Boolean,
      default: false
    },
    multifile: {
      type: Boolean,
      default: false
    },
    typeFile: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.disableDocumentDrag();
  },

  methods: {
    /**
     * * 禁止浏览器默认拖拽事件
     */
    disableDocumentDrag() {
      ['dragleave', 'drop', 'dragenter', 'dragover'].forEach(event => {
        document.addEventListener(event, event => event.preventDefault());
      });
    },

    /**
     * * 选中文件回调
     */
    async handleFileChange({ target: { files } }) {
      if (this.multifile) {
        const promises = [];
        Array.from(files).forEach(file => {
          promises.push(getFileDataURL(file));
        });
        Promise.allSettled(promises).then(result => {
          !!files.length &&
            this.$emit('onFileChange', {
              files,
              result,
              typeFile: this.typeFile
            });
          this.$refs.input.value = '';
        });
      } else {
        !!files.length && this.$emit('onFileChange', { files });
        // this.$refs.input.value = '';
      }
    },

    /**
     * * 拖拽回调
     * @param {Event} event
     */
    handleDragFile({ dataTransfer: { files } }) {
      this.$emit('onFileChange', { files });
      this.$refs.input.value = '';
    }
  }
};
</script>

<style lang="scss">
.hadb-upload {
  position: relative;
  &__input {
    display: none;
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
    left: 0;
    top: 0;
  }
  &__drag {
    display: inline-flex;
    cursor: pointer;
    .drag {
      &-inner {
        flex-direction: column;
        height: 160px;
        width: 224px;
        border: 1px dashed $color-primary;
        background-color: #f7f7f7;
      }
      &-icon {
        color: #fff;
        font-size: 32px;
        &__container {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
      }
      &-label {
        margin-top: 20px;
        color: $color-primary;
        text-align: center;
      }
    }
  }
}
</style>
